import {Doughnut, Line, mixins, Bar} from 'vue-chartjs'

const {reactiveProp} = mixins

export const donutChart = {
    extends: Doughnut,
    mixins: [reactiveProp],
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, {maintainAspectRatio: false, legend: {position: 'bottom'}})
    }
}

export const lineChart = {
    extends: Line,
    mixins: [reactiveProp],
    props: {
        options: {
            type: Object,
            default: {maintainAspectRatio: false, scales: {yAxes: [{ticks: {beginAtZero: true}}]}}
        }
    },
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options)
    }
}

export const barChart = {
    extends: Bar,
    mixins: [reactiveProp],
    props: {
        options: {
            type: Object,
            default: {maintainAspectRatio: false, scales: {yAxes: [{ticks: {beginAtZero: true}}]}}
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}

